import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileProgressComponent } from './profile-progress/profile-progress.component';
import { TableOfContentComponent } from './table-of-content/table-of-content.component';
import { UserActionsComponent } from './user-actions/user-actions.component';
import { SidebarComponent } from './sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CircularSpinnerComponent } from '@app/shared/components/circular-spinner/circular-spinner.component';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { GapFixerIphoneComponent } from '@app/layout/shared/gap-fixer-iphone/gap-fixer-iphone.component';
import { ImageSrcsetComponent } from '@app/shared/components/image-srcset/image-srcset.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';

@NgModule({
  declarations: [SidebarComponent, ProfileProgressComponent, TableOfContentComponent, UserActionsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    CircularSpinnerComponent,
    RouterModule,
    LocalizeRouterModule,
    GapFixerIphoneComponent,
    ImageSrcsetComponent,
    DirectivesModule,
  ],
  exports: [SidebarComponent],
})
export class SidebarModule {}
